<section class="vh100">
    <div class="cw" fxLayout="column">
        <div fxLayoutAlign="center">
            <mat-icon class="ftxxxl gray-4 linkIcon centertext"> verified_user</mat-icon>
        </div>

        <h6 class="h6Title centertext"> Política de privacidad </h6>

        <h6 class="h6Title">1. Aceptación de política de privacidad</h6>
        <p>Los usuarios que accedan a nuestros servicios a través de la Plataforma aceptan sujetarse a las disposiciones
            de esta Política, aceptan que se recopile su información personal a través de cuestionarios, registros,
            formularios electrónicos, entre otros otorgados y/o requeridos virtualmente en la Plataforma, y autorizan a
            PREDYC a hacer uso y realizar el tratamiento de toda la información que brinde a PREDYC. Cabe mencionar, que
            la presente política forma parte integrante de los Términos y Condiciones en
            PREDYC se reserva el derecho a modificar la Política de Privacidad, lo cual será comunicado vía correo
            electrónico con razonable anticipación a su entrada en vigor.
        </p>
        <h6 class="h6Title">2. ¿Qué información recolectamos?</h6>
        <p>Si el Usuario desea acceder a los servicios ofrecidos por la Plataforma, deberá registrarse completando el
            proceso mediante las facilidades que presente la plataforma para tal fin.
            Asimismo, recopilamos información del Usuario relacionada al:
            <br><br>
            <li>contenido compartido dentro de la Plataforma, </li>
            <li>datos de los cursos (comportamiento y uso del producto, comentarios y proyectos creados),</li>
            <li>datos de pago,</li>
            <li>datos sobre las compras.</li>
            <br><br>
            <span class="ft500">PREDYC podrá solicitar otros Datos Personales que considere conveniente en su momento.
                PREDYC no recopila ni almacena: </span>
            <br><br>
            <li>Datos confidenciales del titular de la tarjeta (como todos los números de la tarjeta de crédito o los
                datos de autenticación de la tarjeta).</li>
            <li> Datos sobre las cuentas del usuario en otros servicios, salvo estén conectadas a la cuenta de PREDYC
                Utilizamos distintas pasarelas internacionales para poder realizar los cobros de los Cursos tales como
                Stripe Inc., y Stripe México, entre otras, las cuales procesan toda esta información y al aceptar la
                Política de Privacidad está de acuerdo en compartir su información con las pasarelas de pago
                anteriormente
                señaladas. No tenemos acceso a los datos de la tarjeta de crédito ni de la información dentro de una
                cuenta
                de Paypal.</li>
            <br>
            Le damos la opción al Usuario a que pueda añadir más información a su perfil. El Usuario puede incluir una
            foto de perfil, el país, especialidad, experiencia profesional, nivel educativo entre otros.
        </p>
        <h6 class="h6Title">3. ¿Para qué utilizamos su información?</h6>
        <p>Los datos personales que recopilamos los destinamos de manera enunciativa mas no limitativa para los
            siguientes propósitos:
            <br><br>
            <li>fines de identificación y verificación,</li>
            <li>contacto.</li>
            <li>ofrecerle y entregarle nuestros bienes y servicios,</li>
            <li>identificar historial de compras, y otros fines análogos, (v) mejorar y actualizar nuestros servicios,
            </li>
            <li>procesar las solicitudes y los pedidos de cursos, productos, servicios específicos, información o
                funciones que realiza el usuario,</li>
            <li>comunicarnos con el usuario y generar preferencias de cuenta.
                En la recolección y tratamiento de datos personales que usted nos proporcione, cumplimos todos los
                principios que marca la Ley: licitud, calidad, consentimiento, información, finalidad, lealtad,
                proporcionalidad y responsabilidad.</li>
        </p>
        <h6 class="h6Title">4. ¿Cómo puede limitar el uso o divulgación de su información personal?</h6>
        <p>Usted puede limitar el uso y divulgación de su información personal a través de los siguientes medios que
            hemos instrumentado:
            <br>
            Enviando correo electrónico a la siguiente dirección electrónica: <a href="mailto:contacto@predyc.com" class="blueLink" target="_blank">contacto@predyc.com</a>
        </p>
        <h6 class="h6Title">5. ¿Cómo acceder, rectificar, cancelar u oponerse al tratamiento de sus datos personales?
        </h6>
        <p>El ejercicio de los derechos de acceso, rectificación, cancelación y oposición, revocación del consentimiento
            o negativa al tratamiento de sus datos personales para las finalidades distintas a las señaladas en el
            presente Aviso de Privacidad, podrán efectuarse presentando solicitud por escrito vía correo electrónico a
            <a href="mailto:contacto@predyc.com" class="blueLink" target="_blank">contacto@predyc.com</a></p>
        <h6 class="h6Title">6. Cookies y otra información</h6>
        <p>Utilizamos la dirección IP del usuario para identificar problemas, administrar la Plataforma e identificar
            patrones de comportamiento del tráfico. También se utilizan cookies o tecnología similar para poder
            ofrecerle contenido acorde a sus intereses y para almacenar su contraseña y así el Usuario no tenga que
            ingresarla nuevamente cada vez que regresa a la Plataforma, es importante mencionar que, empleamos distintos
            tipos de cookies, herramientas de recopilación de datos, análisis de perfiles y publicidad en línea. En ese
            sentido, a fin de que cuente con la información a detalle, le solicitamos revisar la Política de Uso de
            Cookies de PREDYC en sitio web <span class="blueLink" routerLink="/politica-cookies">Políticas de Cookies</span></p>
        <h6 class="h6Title">7. ¿Cómo conocer los cambios al presente aviso de privacidad?</h6>
        <p>El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones, por lo cual nos
            comprometemos a mantenerlo informado de tal situación en la primera comunicación que tengamos con usted
            después del cambio, o bien, haciéndolo de su conocimiento en nuestra página web www.predyc.com</p>
        <h6 class="h6Title">8. ¿Cómo contactarnos?</h6>
        <p>Si usted tiene alguna duda sobre el presente Aviso de Privacidad, puede dirigirla a: <a href="mailto:contacto@predyc.com" class="blueLink" target="_blank">contacto@predyc.com</a></p>
    </div>
</section>